import React from "react";
import Moment from "react-moment";
import { Box, Divider, Grid, Typography } from "@material-ui/core";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import moment from "moment";
import { IInvoicesItem } from "src/common/typings/invoices";
import { getLocalDateTime, setDateTimeFormate } from "src/common/utils/app.util";
import { setNumToFixNotRound, moneyformatter } from "src/common/utils/helpers";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonCheckBox from "src/components/CommonCheckBox/CommonCheckBox";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    heading: {
      fontSize: theme.typography.pxToRem(17),
      color: "#000",
      lineHeight: "28px",
    },
    marginLabelText: {
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      //lineHeight: "20px",
    },
    marginLabelHeading: {
      fontWeight: theme.typography.fontWeightRegular,
      color: "rgba(0, 0, 0, 0.54)",
      //lineHeight: "20px",
    },
    termandconduction: {
      color: "red",
      fontStyle: "italic",
      fontSize: 12,
    },
  })
);

type Props = {
  stickyInfo: IInvoicesItem;
  setdrawerStatus: any;
  submitForm: any;
};

export function Sticky({ stickyInfo, setdrawerStatus, submitForm }: Props): React.ReactElement {
  const [ordersData, setOrdersData] = React.useState<any>([]);
  const [selected, setSelected] = React.useState<number>(0);
  const [quickPayTerm, setQuickPayTerm] = React.useState<boolean>(false);

  const today = moment().format("YYYY-MM-DD");
  const classes = useStyles();
  React.useEffect(() => {
    if (stickyInfo.payAmt) {
      const pPay = stickyInfo.payAmt;
      const payPer = stickyInfo.qpPercent;
      const ordDates = [
        {
          id: 1,
          payDate: moment(today, "YYYY-MM-DD").add(1, "days"),
          per: 12,
          payAmt: setNumToFixNotRound((pPay - (pPay / 100) * 12).toString()),
        },
        {
          id: 2,
          payDate: moment(today, "YYYY-MM-DD").add(7, "days"),
          per: 10,
          payAmt: setNumToFixNotRound((pPay - (pPay / 100) * 10).toString()),
        },
        {
          id: 3,
          payDate: moment(today, "YYYY-MM-DD").add(14, "days"),
          per: 7,
          payAmt: setNumToFixNotRound((pPay - (pPay / 100) * 7).toString()),
        },
        {
          id: 4,
          payDate: moment(today, "YYYY-MM-DD").add(21, "days"),
          per: 5,
          payAmt: setNumToFixNotRound((pPay - (pPay / 100) * 5).toString()),
        },
        {
          id: 5,
          payDate: moment(today, "YYYY-MM-DD").add(28, "days"),
          per: 3,
          payAmt: setNumToFixNotRound((pPay - (pPay / 100) * 3).toString()),
        },
      ];
      if (payPer) {
        setSelected(checkForQuickPay());
      }
      if (stickyInfo?.expectedDate) {
        const filteredItems = ordDates.filter(
          (item: any) =>
            moment(item.payDate).format("YYYY-MM-DD") <=
            moment(stickyInfo.expectedDate).format("YYYY-MM-DD")
        );
        setOrdersData(filteredItems);
      } else {
        setOrdersData(ordDates);
      }
    }
  }, [stickyInfo]);
  const checkForQuickPay = () => {
    const payPer = stickyInfo?.qpPercent;
    let sel = 0;
    if (payPer) {
      if (payPer === 12) {
        sel = 1;
      }
      if (payPer === 10) {
        sel = 2;
      }
      if (payPer === 7) {
        sel = 3;
      }
      if (payPer === 5) {
        sel = 4;
      }
      if (payPer === 3) {
        sel = 5;
      }
    }
    return sel;
  };
  return (
    <>
      <Grid container direction="row">
        <Grid item xs={12} md={12}>
          <Box ml={0}>
            <Grid item xs={12} md={12}>
              <Box mt={2}>
                <Typography className={classes.heading}>Invoice Details</Typography>
              </Box>
            </Grid>
            <Divider />
            <Box p={2} mb={3}>
              <Grid container direction="row">
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={6}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>Invoice #:</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {stickyInfo?.invoiceNum || ""}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={6}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>
                          Received Date:
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {getLocalDateTime(stickyInfo?.recievedDate, "MM/DD/YYYY")}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={6}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>Pay Amt:</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {moneyformatter(stickyInfo?.payAmt)}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={6}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>
                          Released Date:
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {getLocalDateTime(stickyInfo?.releaseDate, "MM/DD/YYYY")}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={6}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>Invoice Amt:</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {moneyformatter(stickyInfo?.invoiceAmt)}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={6}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>Due Date:</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {getLocalDateTime(stickyInfo?.expectedDate, "MM/DD/YYYY")}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Grid item xs={12} md={12}>
            <Box mt={2}>
              <Typography className={classes.heading}>QuickPay Detail</Typography>
            </Box>
          </Grid>
          <Divider />
          <Box ml={0}>
            <Box p={2} mb={3}>
              <Grid container direction="row">
                <Grid item xs={12} md={4}>
                  <Box color="text.main">
                    <Typography className={classes.heading}>Due Date</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Box color="text.main">
                    <Typography className={classes.heading}>Percent</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Box color="text.main">
                    <Typography className={classes.heading}>New Amount</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={2}>
                  <Box color="text.main">
                    <Typography className={classes.heading}>Select</Typography>
                  </Box>
                </Grid>
                <Box mb={3} mt={2} />
                {ordersData.map((ditem: any) => {
                  return (
                    <Grid container key={ditem.id} direction="row">
                      <Grid item xs={12} md={12} key={`grid1${ditem.id}`}>
                        <Grid container direction="row">
                          <Grid item xs={12} md={4}>
                            <Box color="text.secondary">
                              <Typography className={classes.marginLabelText}>
                                {/* {ditem.payDate} */}
                                <Moment
                                  local={false}
                                  format="MM/DD/YYYY"
                                  date={ditem.payDate || ""}
                                />
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <Box color="text.main">
                              <Typography className={classes.marginLabelText}>
                                {ditem.per} %
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <Box color="text.main">
                              <Typography className={classes.marginLabelText}>
                                {moneyformatter(ditem.payAmt)}
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <Box mt={-1}>
                              <CommonCheckBox
                                label=""
                                name={ditem.id}
                                value={ditem.id === selected}
                                handleChange={(e: any) => {
                                  if (e.target.checked) {
                                    setSelected(parseInt(e.target.name));
                                  } else {
                                    setSelected(0);
                                  }
                                }}
                              />
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </Box>
          <Grid item xs={12}>
            <Box mt={-1}>
              <CommonCheckBox
                label={
                  'By selecting "Save", you consent to accept reduced payment for quicker pay and NJS agrees to a one time wavier of payment terms by issuing payment wittin the time specified. You understand there is no obligation to participate and the Master Service Agreement remains in full force'
                }
                name={"quickPayTerm"}
                value={quickPayTerm}
                handleChange={(e: any) => {
                  setQuickPayTerm(e.target.checked);
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box mt={2} mb={2} textAlign="right">
              <Box component="span" mr={2}>
                <CommonButton
                  onClick={() => {
                    setdrawerStatus();
                  }}
                >
                  Cancel
                </CommonButton>
              </Box>
              <Box component="span">
                <CommonButton
                  isGreen
                  disable={selected < 1 || !quickPayTerm || selected === checkForQuickPay()}
                  onClick={() => {
                    submitForm(ordersData[selected - 1]);
                  }}
                >
                  Save
                </CommonButton>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.termandconduction}>
              {'* "Next Day" Quick Pay is not available if your billing address is a P.O.box'}
            </Typography>
            <Typography className={classes.termandconduction}>
              {'* "Next Day" Quick Pay will incur an overnight shipping charge of $35.00'}
            </Typography>
            <Typography className={classes.termandconduction}>
              {
                '* "Next Day" Quick Pay options will ship same business day if selected before 2:00pm EST. Invoices selected after 2:00pm EST,Saturday,Sunday or holidays will be processed the next business day.'
              }
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
